import { UIDataTypes, UIMessagePart, UITools, isToolUIPart } from 'ai';
import RachelMarkdown from '../RachelMarkdown/RachelMarkdown';
import ToolPart from '../ToolPart/ToolPart';
import RachelFilePartView from './components/RachelFilePartView/RachelFilePartView';
import RachelReasoningPart from './components/RachelReasoningPart/RachelReasoningPart';
import RachelVizPart from './components/RachelVizPart/RachelVizPart';
import { getWebVisualizationBlocks } from './components/RachelVizPart/rachelVizPart.utils';

interface RachelMessagePartProps {
  part: UIMessagePart<UIDataTypes, UITools>;
}

const RachelMessagePart = ({ part }: RachelMessagePartProps) => {
  if (part.type === 'text') {
    return <RachelMarkdown>{part.text}</RachelMarkdown>;
  }

  if (part.type === 'reasoning') {
    return <RachelReasoningPart text={part.text} />;
  }

  if (part.type === 'file') {
    return <RachelFilePartView part={part} />;
  }

  if (isToolUIPart(part)) {
    const vizBlocks = getWebVisualizationBlocks(part);
    return vizBlocks.length > 0 ? <RachelVizPart blocks={vizBlocks} /> : <ToolPart part={part} />;
  }

  return null;
};

export default RachelMessagePart;
